import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polygon, { points: "6 3 18 3 22 9 12 22 2 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m12 22 4-13-3-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 22 8 9l3-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 9h20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Gem";
const Gem = memo(themed(Icon));
export {
  Gem
};
//# sourceMappingURL=gem.js.map
